'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ua = require('@ali/simple-ua');
var log = require('@ali/log');
var network = require('@ali/network');
var isLoadNewsDAUSDK = false;
var IN_SDK = 'https://ucnews.ucweb.com/cp-lib/js/logsdk.js'; // 印度生产环境sdk
var ID_SDK = 'https://id.ucnews.ucweb.com/cp-lib/js/logsdk.js'; // 印尼生产环境sdk

/**
 * 日活打点可选语言值
 */
var availableDAULang = exports.availableDAULang = ['english', 'hindi', 'indonesian', 'tamil', 'telugu', 'gujarati', 'marathi', 'bengali', 'kannada', 'malayalam', 'punjabi', 'assamese', 'oriya', 'manipuri', 'urdu', 'bhojpuri'];

/**
 * 日活打点可选国家值
 */
var availableDAUNation = exports.availableDAUNation = ['IN', 'ID'];

/**
 * 统计活动对头条、浏览器信息流的日活贡献
 * 需求： http://doc.ucweb.local/pages/viewpage.action?pageId=287447101
 * 接口文档：http://doc.ucweb.local/pages/viewpage.action?pageId=265228984
 * 接口人：@张绍基, @李庆文
 * logBus.newsDAU
 */
var newsDAU = function newsDAU(_ref) {
  var _ref$isNewsAct = _ref.isNewsAct,
      isNewsAct = _ref$isNewsAct === undefined ? false : _ref$isNewsAct,
      _ref$isBrowserAct = _ref.isBrowserAct,
      isBrowserAct = _ref$isBrowserAct === undefined ? false : _ref$isBrowserAct,
      _ref$actname = _ref.actname,
      actname = _ref$actname === undefined ? log.baseParam('actname') : _ref$actname,
      _ref$lang = _ref.lang,
      lang = _ref$lang === undefined ? 'english' : _ref$lang,
      na = _ref.na,
      ac = _ref.ac,
      reco_id = _ref.reco_id,
      item_id = _ref.item_id,
      app = _ref.app,
      site = _ref.site,
      source = _ref.source,
      cate_id = _ref.cate_id,
      ch_id1 = _ref.ch_id1,
      entry1 = _ref.entry1,
      _ref$entry = _ref.entry2,
      entry2 = _ref$entry === undefined ? actname : _ref$entry,
      _ref$ct_lang = _ref.ct_lang,
      ct_lang = _ref$ct_lang === undefined ? lang : _ref$ct_lang,
      sdkUrl = _ref.sdkUrl,
      otherArgs = _objectWithoutProperties(_ref, ['isNewsAct', 'isBrowserAct', 'actname', 'lang', 'na', 'ac', 'reco_id', 'item_id', 'app', 'site', 'source', 'cate_id', 'ch_id1', 'entry1', 'entry2', 'ct_lang', 'sdkUrl']);

  // 没有打开开关，直接返回，不进行任何操作
  if (!isNewsAct && !isBrowserAct) return;

  // 按产品对活动的划分，若活动被划分为News类活动，则需要把活动的日活打到头条logserver
  // 按产品对活动的划分，若活动被划分为Browser/Browser 信息流类活动，则需要把活动的日活打到浏览器信息流logserver
  if (isNewsAct && ua.pf === 'UCNEWS' || isBrowserAct && ua.pf === 'UC') {
    app = app || (ua.pf === 'UCNEWS' ? 'app_iflow' : 'browser_iflow');

    if (!ac) {
      // ac 的特殊处理: http://doc.ucweb.local/pages/viewpage.action?pageId=335962334
      // 消息推送方会给 url 加上 entry1=push_xxx 和 uc_biz_str
      // 检查到这两个值都符合则 ac=push，否则是写死的 ac=deeplink
      var _entry2 = network.query('entry1');
      var uc_biz_str = network.query('uc_biz_str');
      ac = isStartsWith(_entry2, 'push') && !!uc_biz_str ? 'push' : 'deeplink';
    }

    if (!item_id) {
      // 消息推送方会给 url 加上 item_id，如果有就带上，没有就写死 item_id=activity 吧
      item_id = network.query('item_id') || 'activity';
    }

    if (!entry1) {
      // 消息推送方会给 url 加上 entry1，如果有就带上，没有就写死 item_id=activity 吧
      entry1 = network.query('entry1') || 'activity';
    }

    // 他们的 entry 概念跟活动侧的 entry 不是一个东西，不要混淆了！！
    var _entry = ua.pf === 'UCNEWS' ? 'news' : 'browser';

    var _getParamsValue = getParamsValue(),
        ver = _getParamsValue.ver,
        sver = _getParamsValue.sver;

    var params = {
      logs: [_extends({
        ac: ac,
        ct_lang: ct_lang,
        reco_id: reco_id,
        item_id: item_id,
        app: app, // 头条客户端:app_iflow, 浏览器信息流:browser_iflow
        site: site, // 种子名称，业务方自己定义
        source: source, // 种子来源，业务方自己定义
        cate_id: cate_id, // 分类id
        ch_id1: ch_id1 }, otherArgs)],
      queries: {
        lang: lang,
        entry: _entry,
        entry1: entry1,
        entry2: entry2,
        uc_param_str: 'dsdnfrpfbivesscpgimibtbmnijblauputogpintnwmtsvch',
        // UC 浏览器没有 ver 和 sver，手动补充
        ver: ver,
        sver: sver,
        uc_biz_str: network.query('uc_biz_str')
      },
      success: function success(data) {
        console.log(data);
        log.logVisit('logserversuccess');
      },
      fail: function fail(error) {
        console.log(error);
        log.logVisit('logserverfail', {
          error: error.message,
          href: window.location.href
        });
      }
    };
    if (!isLoadNewsDAUSDK) {
      var scriptURL = sdkUrl || (na === 'IN' ? IN_SDK : ID_SDK);
      // 未load日志
      loadScript(scriptURL, function () {
        reqDAU(params);
        isLoadNewsDAUSDK = true;
      });
    } else {
      reqDAU(params);
    }
  }
};

exports.newsDAU = newsDAU;
function reqDAU(params) {
  try {
    window.ucnews.logserver(params);
    log.logVisit('logservertest');
  } catch (error) {
    console.log(error);
  }
}

function loadScript(url, cb) {
  var script = document.createElement('script');
  script.onload = function () {
    cb();
    console.log('Script loaded and ready');
  };
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}

// 日活 logserver 必须带上 ver 和 sver，但是 browser 只有 ve 和 sv，这里做一下兼容
function getParamsValue() {
  // 降级：先取 query，再取 window.__UC_PARAMS__ ，再从 ua 抓，都没有就空字符串
  var veFromWindow = window.__UC_PARAMS__ ? window.__UC_PARAMS__.ve : '';
  var svFromWindow = window.__UC_PARAMS__ ? window.__UC_PARAMS__.sv : '';
  return {
    ver: network.query('ve') || veFromWindow || ua.getUCVersion() || 'unknown',
    sver: network.query('sv') || svFromWindow || 'unknown'
  };
}

/**
 * 是否以特定字符串开头
 *
 * @param {string} str 长字符串
 * @param {string} search 搜索字符串
 * @return {boolean} str 以 search 开头为 true ，否则为 false
 */
function isStartsWith(str, search) {
  if (typeof str !== 'string') return false;
  return str.substr(0, search.length) === search;
}